import { OutputData } from '@editorjs/editorjs'

import { HERO_TYPE_ENUM } from './ambulance'
import { IBase, IBasePublishable, IImage } from './base'
import { PRICE_GROUP_ITEM_FORM_TYPE_ENUM, PRICE_GROUP_TYPE_ENUM } from './price-group'

export interface IPriceListItemBenefit {
	icon: string
	text: string
	sortOrder: number
	uuid: string
}

export enum PRICE_LIST_ITEM_TYPE_ENUM {
	SERVICE = 'sluzba',
	PACKAGE = 'balikns'
}

export enum PRICE_LIST_ITEM_BUTTON_TYPE_ENUM {
	DEFAULT = 'DEFAULT',
	TIMESLOTS = 'TIMESLOTS'
}

export interface IPriceListItem extends IBase {
	type: PRICE_LIST_ITEM_TYPE_ENUM
	name: string
	slug: string | null
	description: string | null
	text: string | null
	aladarId: number
	aladarName: string
	aladarDescription: string | null
	priceAction: string
	priceText: string | null
	price: number | null
	priceDovera: number | null
	priceDoveraText?: string
	priceUnion: number | null
	priceUnionText?: string
	priceVszp: number | null
	priceVszpText?: string
	priceInsurance: number | null
	priceInsuranceText?: string
	priceOld: number | null
	priceOldText?: string
	formType: PRICE_GROUP_ITEM_FORM_TYPE_ENUM
	buttonType: PRICE_LIST_ITEM_BUTTON_TYPE_ENUM | undefined
	groupId: number
	createdAt: string
	updatedAt: string
	priceCapit: number | null
	priceCapitText?: string
	priceNoCapit: number | null
	priceNoCapitText?: string
	benefits: IPriceListItemBenefit[] | null
	sortOrder: number
	_uuid?: string
}

export interface IPriceListGroup extends IBase, IBasePublishable {
	name: string
	type: PRICE_GROUP_TYPE_ENUM
	slug: string | null
	text: OutputData
	items: IPriceListItem[]
	sortOrder?: number
	heroImage: IImage
	heroText: string | null
	heroTitle: string | null
	heroButtonText: string | null
	heroButtonLink: string | null
	heroType: HERO_TYPE_ENUM | null
	_uuid?: string
}
